export const getBannerNameFromImageUrl = (imageUrl: string | null | undefined = '') => {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return '';
  }

  const pathWithoutQueryOrHash = imageUrl.split(/[?#]/)[0];
  const encodedFileName = pathWithoutQueryOrHash.split('/').pop();

  if (!encodedFileName) {
    return '';
  }

  let fileName = encodedFileName;

  try {
    fileName = decodeURIComponent(encodedFileName);
  } catch {
    // Keep the undecoded filename when the URL contains malformed encoding.
  }

  return fileName.replace(/\.[^./]+$/, '');
};

export const getBannerTracking = ({
  bannerImgUrl,
  isCarousel = false,
  position,
  bannerLocation,
  linkName,
}: {
  bannerImgUrl?: string | null; isCarousel?: boolean; position?: number;
  bannerLocation: string; linkName?: string | null;
}) => ({
  bannerName: getBannerNameFromImageUrl(bannerImgUrl),
  bannerCategory: isCarousel ? 'carousel' : 'static-banner',
  bannerLocation: isCarousel && Number.isFinite(position)
    ? `${bannerLocation}-pos-${position}`
    : bannerLocation,
  linkName,
});
